import { globalStyle, style } from '../layer.css.ts';
import { responsiveStyle } from '../responsive/responsive-style.ts';
import { themeV2 } from '../theme-v2/vars.ts';
import { space } from '../tokens';
import { typography } from '../typography';
import { ellipsis } from '../utility.css.ts';

export const streamRowV2 = style({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  gap: space.s12,
  width: '100%',
  padding: space.s12,
  backgroundColor: themeV2.color.bg.surface.secondary,
  ...responsiveStyle({
    tablet: {
      display: 'grid',
      gridTemplateColumns: 'minmax(0, 1fr) 18px 12rem 4.5rem 6.5rem auto',
      alignItems: 'center',
      columnGap: space.s16,
      rowGap: 0,
    },
  }),
});

export const streamRowV2Main = style({
  display: 'flex',
  flexDirection: 'column',
  minWidth: 0,
  width: '100%',
});

export const streamRowV2Copy = style({
  display: 'flex',
  flexDirection: 'column',
  gap: space.s4,
  minWidth: 0,
  width: '100%',
});

export const streamRowV2Title = style([
  ellipsis,
  {
    ...typography.labelMd,
    margin: 0,
    color: themeV2.color.text.primary,
  },
]);

export const streamRowV2Description = style({
  ...typography.bodySm,
  margin: 0,
  color: themeV2.color.text.quaternary,
  display: '-webkit-box',
  WebkitLineClamp: 1,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
});

export const streamRowV2Meta = style({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: space.s12,
  flexShrink: 0,
  pointerEvents: 'none',
  ...responsiveStyle({
    tablet: {
      display: 'contents',
    },
  }),
});

export const streamRowV2Handle = style({
  position: 'relative',
  zIndex: 2,
  pointerEvents: 'auto',
  minWidth: 0,
  width: 'fit-content',
  maxWidth: '100%',
  ...responsiveStyle({
    tablet: {
      justifySelf: 'start',
    },
  }),
});

export const streamRowV2Featured = style({
  display: 'none',
  alignItems: 'center',
  justifyContent: 'center',
  width: 18,
  height: 18,
  flexShrink: 0,
  color: themeV2.color.text.secondary,
  selectors: {
    '&:not(:empty)': {
      display: 'inline-flex',
    },
  },
  ...responsiveStyle({
    tablet: {
      display: 'inline-flex',
    },
  }),
});

export const streamRowV2View = style({
  position: 'relative',
  zIndex: 2,
  pointerEvents: 'auto',
  flexShrink: 0,
});

globalStyle(`.${streamRowV2Featured} :where(svg)`, {
  width: 18,
  height: 18,
  flexShrink: 0,
});
